import AnimatedButtonTypes from './types';
import MojitoCore from 'mojito/core';
import Button from 'presentation/components/button/index.js';
import AbsolutePane from 'presentation/components/absolute-pane/index.js';
import FlexPane from 'presentation/components/flex-pane/index.js';
import Spinner from 'presentation/components/spinner/index.js';
import { noop } from 'mojito/utils';

const UIViewImplementation = MojitoCore.Presentation.UIViewImplementation;
const uiStyle = MojitoCore.Presentation.uiStyle;
const classUtils = MojitoCore.Base.classUtils;

const ACTIVE_ANIMATION_NAME = 'animatedButtonProgressBar';

export default class AnimatedButton extends UIViewImplementation {
    renderChildrenContent() {
        return <FlexPane config={this.config.childrenContainer}>{this.props.children}</FlexPane>;
    }

    wrapWithSpinner(content) {
        return (
            <FlexPane config={this.config.spinnerWithContentContainer}>
                <Spinner config={this.config.spinner} />
                {content}
            </FlexPane>
        );
    }

    render() {
        const state = this.props.state;
        const isDisabled = state === AnimatedButtonTypes.STATES.DISABLED;
        const isAnimating = state === AnimatedButtonTypes.STATES.ANIMATING;

        const isCustomState =
            state === AnimatedButtonTypes.STATES.CONFIRM ||
            state === AnimatedButtonTypes.STATES.FAIL ||
            state === AnimatedButtonTypes.STATES.SUCCESS;

        const isSpinnerAnimation = isAnimating && this.config.isSpinner;
        const isSlidingAnimation = isAnimating && !this.config.isSpinner;

        const childrenContent = this.renderChildrenContent();

        return (
            <Button
                class={classUtils.classNames('ta-AnimatedButton-button', this.props.class)}
                config={isCustomState ? this.style[state] : this.config.button}
                onClick={isAnimating ? noop : this.props.onClick}
                disabled={isDisabled}
                onHoverChange={this.props.onHoverChange}
            >
                {isSlidingAnimation && (
                    <AbsolutePane config={this.config.animatedBackgroundContainer}>
                        <div
                            style={this.style.animatedBackground}
                            className="AnimatedButton-animated_background"
                        />
                    </AbsolutePane>
                )}
                {isSpinnerAnimation ? this.wrapWithSpinner(childrenContent) : childrenContent}
            </Button>
        );
    }
}

AnimatedButton.getStyle = function (config, mode, merge) {
    const animation = uiStyle.createCssAnimation(config, ACTIVE_ANIMATION_NAME, config.animation);
    return {
        animatedBackground: merge(config.style.animatedBackground, animation),
        confirm: merge(config.button, config.confirm),
        success: merge(config.button, config.success),
        fail: merge(config.button, config.fail),
    };
};
